var _defs, _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReview = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52.03 54.73",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Asset 9")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,41.88A12.37,12.37,0,1,1,45.36,29.52,12.38,12.38,0,0,1,33,41.88ZM33,19A10.55,10.55,0,1,0,43.54,29.52,10.56,10.56,0,0,0,33,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.4,48.56a2.64,2.64,0,0,1-1.86-.77h0L39.35,39.6a.9.9,0,0,1-.26-.64.92.92,0,0,1,.26-.65l2.44-2.43a.91.91,0,0,1,1.29,0l8.18,8.18a2.64,2.64,0,0,1-1.86,4.5Zm-.58-2.06A.82.82,0,1,0,50,45.35L42.43,37.8,41.28,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,20.68a.9.9,0,0,1-.64-.27L8.32,18.34A.91.91,0,0,1,9.6,17.06L11,18.49l3.5-3.5a.91.91,0,1,1,1.28,1.28l-4.14,4.14A.89.89,0,0,1,11,20.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,31a.9.9,0,0,1-.64-.27L8.32,28.69A.91.91,0,0,1,9.6,27.41L11,28.83l3.5-3.49a.91.91,0,0,1,1.28,1.28l-4.14,4.14A.89.89,0,0,1,11,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,41.37a.93.93,0,0,1-.64-.26L8.32,39A.91.91,0,1,1,9.6,37.75L11,39.18l3.5-3.5A.91.91,0,0,1,15.81,37l-4.14,4.14A.92.92,0,0,1,11,41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.66,20.68H19.83a.91.91,0,0,1,0-1.82h6.83a.91.91,0,0,1,0,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.54,31H19.83a.91.91,0,0,1,0-1.82h1.71a.91.91,0,0,1,0,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.61,41.37H19.83a.91.91,0,1,1,0-1.81h9.78a.91.91,0,0,1,0,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.65,8.45H33a.9.9,0,0,1-.9-.91V.91A.91.91,0,0,1,33.66.27L40.29,6.9a.91.91,0,0,1-.64,1.55ZM33.92,6.63h3.54L33.92,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,54.73H.91a.9.9,0,0,1-.91-.9V2.57A2.57,2.57,0,0,1,2.57,0H33a.91.91,0,0,1,.65.27L40.29,6.9a.91.91,0,0,1,.27.64V20.19a.91.91,0,1,1-1.82,0V7.92l-6.1-6.1H2.57a.76.76,0,0,0-.75.75V52.92H38a.76.76,0,0,0,.76-.76v-13a.91.91,0,1,1,1.82,0v13A2.58,2.58,0,0,1,38,54.73Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/review.18eeb793.svg";
export { ForwardRef as ReactComponent };